import React from "react";
import FilterUserProto from "../lib/user-field-proto";

export default class FilterField2User extends FilterUserProto {

    constructor(filtersManager, field, initValue) {
        super(filtersManager, field, initValue, field.label);

        // this.filterConfig is field2 object

        this.field = this.filterConfig.fieldId;
        this.isCustomField = this.filterConfig.isCustom;
        this.noOptionLabel = "Not set";
    }

    optionsFillerFunc(dataItem) {
        let value = dataItem[this.filterConfig.fieldId];
        if(_.isNil(value)) value = null;
        this.optionsSet.add(value);
    }

    filterFunc(dataItem) {
        if (!this.value) return true; //null;
        let value = dataItem[this.filterConfig.fieldId];
        if(_.isNil(value)) value = null;
        return this.value.includes(value);
    }

    filterFuncUniversal(dataItem) {return this.filterFunc(dataItem)}
}